// @flow
import { ContratosActionTypes } from './constants';

// import { APICore } from '../../helpers/api/apiCore';

// const api = new APICore();

const INIT_STATE = {
    contrato: {},
    listaContratos: [],
    formSubmited: false,
    loading: false,
    error: false
};

type ContratosAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};
type State = { contrato?: {} | null, listaContratos?: [] | null, loading?: boolean, +value ?: boolean };

const Contratos = (state: State = INIT_STATE, action: ContratosAction): any => {
    // console.log(action);
    switch (action.type) {
        case ContratosActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case ContratosActionTypes.GET_CONTRATO: {
                    return {
                        ...state,
                        contrato: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case ContratosActionTypes.LIST_CONTRATOS: {
                    return {
                        ...state,
                        listaContratos: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case ContratosActionTypes.CREATE_CONTRATO: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    }
                }
                case ContratosActionTypes.UPDATE_CONTRATO: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    }
                }
                default:
                    return { ...state };
            }

        case ContratosActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case ContratosActionTypes.GET_PRODUCTO: {
                    return {
                        ...state,
                        error: action.payload.error,
                        contrato: {},
                        loading: false,
                    };
                }
                case ContratosActionTypes.LIST_CONTRATOS: {
                    return {
                        ...state,
                        error: action.payload.error,
                        listaContratos: [],
                        loading: false,
                    };
                }
                case ContratosActionTypes.CREATE_CONTRATO: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    }
                }
                case ContratosActionTypes.UPDATE_CONTRATO: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    }
                }
                default:
                    return { ...state };
            }

        case ContratosActionTypes.GET_CONTRATO:
            return { ...state, error: false, loading: true };
        case ContratosActionTypes.LIST_CONTRATOS:
            return { ...state, error: false, loading: true };
        case ContratosActionTypes.CREATE_CONTRATO:
            return { ...state, error: false, loading: true };
        case ContratosActionTypes.UPDATE_CONTRATO:
            return { ...state, error: false, loading: true };
        case ContratosActionTypes.RESET:
            return {
                ...state,
                loading: false,
                error: false,
                contrato: {},
                listaContratos: [],
                formSubmited: false
            };
        case ContratosActionTypes.RESET_CONTRATO:
            return {
                ...state,
                loading: false,
                error: false,
                contrato: {},
                formSubmited: false
            };
        default:
            return { ...state };
    }
};

export default Contratos;
